// extracted by mini-css-extract-plugin
export default {"skillBlock":"Skill_skillBlock__ApiTg","title":"Skill_title__1LTkK"};